import { useNavigate } from "react-router-dom";

import { BUTTON_VARIANT_TYPES, NO_ACCESS_TYPES, PERMISSIONS } from "../../../../utils/constants";
import { PencilIcon } from "@heroicons/react/solid";

import Button from "../../../SharedComponents/Button";
import AccessControl from "../../../SharedComponents/AccessControl";

function UserGroupRow(props) {
    const { item: userGroup } = props;

    const navigate = useNavigate();

    const handleGoToUserGroup = (userGroup) => {
        navigate("/user-groups/edit-user-group", {
            state: {
                userGroupName: userGroup.name,
            },
        });
    };

    return (
        <tr className={userGroup.isDefault ? "bg-green-50" : ""}>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-indigo-900">{userGroup.name}</div>
                    {userGroup.isDefault && (
                        <span className={"bg-green-500 text-xs text-white rounded-full p-1 px-2"}>Default</span>
                    )}
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-indigo-900">
                        {userGroup.parentGroupName || "No parent group"}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className={"text-xs font-medium text-secondary-600 bg-secondary-100 p-1 px-2 rounded-full"}>
                        {userGroup.users.length} user{userGroup.users.length > 1 && "s"}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className={"text-xs font-medium text-secondary-600 bg-secondary-100 p-1 px-2 rounded-full"}>
                        {userGroup.permissions.length} permission{userGroup.permissions.length > 1 && "s"}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className={"text-xs font-medium text-secondary-600 bg-secondary-100 p-1 px-2 rounded-full"}>
                        <span>
                            {userGroup.applications.length} application{userGroup.applications.length !== 1 && "s"}
                        </span>
                    </div>
                </div>
            </td>
            <AccessControl requiredPermission={PERMISSIONS.EDIT_USER_GROUPS} noAccessType={NO_ACCESS_TYPES.BLANK}>
                <td className="px-4 py-3 whitespace-nowrap">
                    <div className={"flex flex-row gap-3 items-center"}>
                        <Button
                            onClick={() => handleGoToUserGroup(userGroup)}
                            iconPositionLeft
                            icon={<PencilIcon className="block h-3.5 w-3.5 mr-2" />}
                            colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                            text="Edit"
                            extraStyling="shadow-none text-primary-600 p-0 focus:ring-0 focus:transparent"
                        />
                    </div>
                </td>
            </AccessControl>
        </tr>
    );
}

export default UserGroupRow;
